import { UseFormReturn } from 'react-hook-form';
import { MiscellaneousField } from '../../reportsTypes';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  InfoIconTooltip,
  Switch,
} from '@ais-ui/ui-core';
import * as z from 'zod';
import { createDynamicMiscellaneousZodSchema } from '../utils/createDynamicMiscellaneousZodSchema';

interface BooleanItemProps {
  fieldName: string;
  form: UseFormReturn;
  fieldInfo: MiscellaneousField;
}

export const MiscellaneousBooleanItem = ({
  fieldName,
  form,
  fieldInfo,
}: BooleanItemProps) => {
  return (
    <FormField
      key={fieldName}
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem className="flex flex-col space-y-4">
          <div className="flex justify-between">
            <FormLabel>
              {fieldInfo.name}: {fieldInfo.required && '*'}
            </FormLabel>
            {fieldInfo.help && (
              <InfoIconTooltip>{fieldInfo.help}</InfoIconTooltip>
            )}
          </div>
          <FormControl onChange={() => form.clearErrors()}>
            <Switch
              defaultValue={fieldInfo.defaultValue}
              checked={!!field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
export type ReportTemplateMiscellaneousValues = z.infer<
  ReturnType<typeof createDynamicMiscellaneousZodSchema>
>;
